import axios from "axios"

const ContactService = {}

ContactService.ajouter =(data)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/contact/ajouter`,data)

}
export default ContactService ;